import router from '@/router'
import {
  auth,
  db
} from "../api"; //import all foder api
import Admins from '../config/admin'
export const actions = {
  // signup({
  //   commit
  // }, payload) {
  //   commit('setLoading', true)
  //   auth.createUserWithEmailAndPassword(payload.email, payload.password)
  //     .then(firebaseUser => {
  //       console.log(firebaseUser)
  //       commit('setUser', firebaseUser)
  //       commit('setError', false)
  //       commit('setLoading', false)
  //       router.push('/main')
  //     })
  //     .catch(error => {
  //       commit('setError', true)
  //       commit('setLoading', false)
  //     })
  // },
  forgot({
    commit
  }, payload) {
    commit('setLoading', true)
    auth.sendPasswordResetEmail(payload.email)
      .then(firebaseUser => {
        commit('setError', false)
        commit('setLoading', false)
        commit('setSuccess', true)
      })
      .catch(error => {
        commit('setError', true)
        commit('setLoading', false)
      })
  },
  login({
    commit
  }, payload) {
    commit('setLoading', true)

    auth.signInWithEmailAndPassword(payload.email, payload.password)
      .then(res => {
        res = res.user
        if (Admins.indexOf(res.email) < 0) {
          throw "is too low";
        }
        commit('setUser', res.displayName ? res.displayName : res.email)
        commit('setUid', res.uid)
        commit('setEmail', res.email)
        commit('setLoading', false)
        commit('setError', false)
        commit('setEmail', payload.email)
        router.push('/main')
      })
      .catch(error => {
        commit('setError', true)
        commit('setLoading', false)
      })
  },
  autoSignIn({
    commit,
    dispatch
  }, payload) {
    if (payload) {
      if (Admins.indexOf(payload.email) < 0) {
        return router.push('/login')
      }
      commit('setUser', payload.displayName ? payload.displayName : payload.email)
      commit('setUid', payload.uid)
      commit('setEmail', payload.email)
      dispatch('getData', payload.uid)
    }
  },
  userSignOut({
    commit
  }) {
    auth.signOut()
    commit('setUser', null)
    router.push('/login')
  },
  getInsureCompany({
    commit
  }) {
    const data = []
    db.collection("insure_company").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id;
          data.push(item)
        })
        commit('setInsureCompany', data)
      })
    // .catch(err => console.log(err))
  },
  regisData({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").add(payload).then(function (docRef) {
      commit('setRegisId', docRef.id)
      commit('setLoading', false)
      commit('setSuccess', true)
    })
  },
  saveData({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").doc(payload.id).update(payload).then(function () {
      commit('setUserData', payload)
      commit('setLoading', false)
      commit('setSuccess', true)
    })
  },
  getData({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").where('site', '==', 'tm.brokertg.com')
      .where('uid', '==', payload).get()
      .then(snapshot => {
        if (!snapshot.empty) {
          commit('setRegisId', snapshot.docs[0].id)
          commit('setUserData', snapshot.docs[0].data())
        }
        commit('setLoading', false)
      })
  },
  getAgents({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").where('site', '==', payload).get()
      .then(snapshot => {
        let data = null
        if (!snapshot.empty) {
          data = []
          snapshot.forEach(doc => {
            let item = doc.data()
            item.id = doc.id;
            data.push(item)
          })
        }
        commit('setAgents', data)
        commit('setLoading', false)
      })
  },
  saveAgent({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").doc(payload.id).update(payload).then(function () {
      commit('setUpdateAgent', payload)
      commit('setLoading', false)
      commit('setSuccess', true)
    })
  },
  logout({
    commit
  }) {
    auth.signOut()
    // localStorage.clear()
    commit('setUser', null)
    router.push('/login')
  },
  getDataById({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").doc(payload).get()
      .then(snapshot => {
        if (snapshot.id) {
          // commit('setRegisId', snapshot.id)
          const data = snapshot.data()
          if (data.affiliate) {
            db.collection("members").where('site', '==', 'tm.brokertg.com')
              .where('uid', '==', data.affiliate).get()
              .then(snapshot => {
                if (!snapshot.empty) {
                  const affiliate = snapshot.docs[0].data()
                  if (affiliate) {
                    data.affName = affiliate.fullName
                    data.affNumber = affiliate.license
                    data.affMobile = affiliate.mobile
                  } else {
                    data.affName = "บริษัท เดอะกู๊ด โบรกเกอร์ จำกัด"
                    data.affNumber = "2179381"
                    data.affMobile = "081-6590467 (พนิดา ธรรมลังกา)"
                  }
                  commit('setMemberData', data)
                }
                commit('setLoading', false)
              })
          } else {
            data.affName = "บริษัท เดอะกู๊ด โบรกเกอร์ จำกัด"
            data.affNumber = "2179381"
            data.affMobile = "081-6590467 (พนิดา ธรรมลังกา)"
            commit('setMemberData', data)
            commit('setLoading', false)
          }
        } else {
          commit('setLoading', false)
        }
      })
  },
  getDataById2({
    commit
  }, payload) {
    commit('setLoading', true)
    db.collection("members").doc(payload).get()
      .then(snapshot => {
        if (snapshot.id) {
          // commit('setRegisId', snapshot.id)
          const data = snapshot.data()
          if (data.affiliate) {
            db.collection("members").where('site', '==', 'srikrung.brokertg.com')
              .where('uid', '==', data.affiliate).get()
              .then(snapshot => {
                if (!snapshot.empty) {
                  const affiliate = snapshot.docs[0].data()
                  if (affiliate) {
                    data.affName = affiliate.fullName
                    data.affNumber = affiliate.license
                    data.affMobile = affiliate.mobile
                  }
                  commit('setMemberData', data)
                }
                commit('setLoading', false)
              })
          } else {
            commit('setMemberData', data)
            commit('setLoading', false)
          }
        } else {
          commit('setLoading', false)
        }
      })
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js